import React from 'react';
import { Button, Typography, Popconfirm, Row, Col } from 'components';
import { FullscreenOutlined, DeleteOutlined } from '@ant-design/icons';
import { SavedImage } from 'components/common/icons/warehouse/SavedImage';
import styles from './AdditionalImages.module.scss';

const { Text } = Typography;

interface ImageItem {
  file: File | null;
  url: string;
  attachmentId?: string;
  fileName?: string;
}

interface AdditionalImagesProps {
  images: ImageItem[];
  onPreview: (url: string) => void;
  onDelete: (index: number) => void;
}

export const AdditionalImages: React.FC<AdditionalImagesProps> = ({ images, onPreview, onDelete }) => {
  if (images.length === 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      <Text className={styles.title}>Additional Photos ({images.length})</Text>
      <Row gutter={[12, 12]}>
        {images.map((img, index) => (
          <Col key={index} xs={8} sm={6} md={4}>
            <div className={styles.imageCard}>
              <img src={img.url} alt={`Additional ${index + 1}`} className={styles.image} />

              {/* Action Buttons - Top Right */}
              <div className={styles.actionsTop}>
                <Button
                  type="text"
                  icon={<FullscreenOutlined />}
                  size="small"
                  onClick={() => onPreview(img.url)}
                  className={styles.actionBtn}
                />
                <Popconfirm
                  title="Delete image"
                  description="Are you sure you want to delete this image?"
                  onConfirm={() => onDelete(index)}
                  okText="Delete"
                  cancelText="Cancel"
                  okButtonProps={{ danger: true }}
                >
                  <Button type="text" icon={<DeleteOutlined />} size="small" danger className={styles.actionBtn} />
                </Popconfirm>
              </div>

              {/* Saved Badge - Bottom Right */}
              {img.attachmentId && (
                <div className={styles.savedBadge}>
                  <SavedImage />
                </div>
              )}
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};
